.heroContent {
  display: flex;
  flex-direction: column;
  max-width: 500px;
  height: auto;
  position: absolute;
  /* top: 50%;
  left: 3vw; */
  bottom: 0;
  left: 30%;
  transform: translateY(-50%);
  padding: 3rem;
  border-radius: 10px;
  /* gap: 20px; */
  /*background: #e9e9e9;*/
  /*background: rgb(233, 233, 233, 0.7);*/
}

.heroContent div span {
  color: #ff9500;
  font-weight: 400;
  font-size: 18px;
}

.heroHeader {
  font-size: 13px;
  margin: 0;
  color: #fffdf7;
  margin-bottom: 5px;
  font-weight: 300 !important;
}

.visuallyHiddenHeader {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.heroTitle {
  font-size: 38px;
  font-weight: 300;
  line-height: 1.35;
  letter-spacing: 1px;
  color: #fffdf7;
  margin: 0;
}

.heroSubtitle {
  margin: 30px 0;
  display: flex;
  flex-direction: row;
}

.heroSubtitle p {
  font-size: 18px;
}

.heroSubtitle ol {
  list-style: none;
  padding: 0;
  --height: 1.7rem;
  height: var(--height);
  line-height: var(--height);
  overflow: hidden;
}

.heroSubtitle ol li {
  animation: slide-up 8s infinite;
}

.heroSubtitle ol li span {
  white-space: nowrap;
}

.heroButtonContainer {
  margin-top: 20px;
}

.heroComment {
  font-size: 17px;
  font-weight: 200;
  color: #505050;
}

@media (max-width: 1024px) {
  /* .heroContent {
    left: 10vw;
    max-width: 450px;
    padding: 2.8rem;
  } */
  .heroContent {
    bottom: -10%;
    left: 1%;
  }
  .heroHeader {
    font-size: 12px;
    font-weight: 200;
  }
  .heroTitle {
    font-size: 28px;
  }
}

@media (max-width: 480px) {
  .heroContent {
    bottom: -8%;
    left: 1%;
  }
  .heroTitle {
    font-size: 22px;
  }
}
